/**
 * C7 — elenco campi mancanti FatturaPA, raggruppati per "dove" con link di correzione.
 * Riusato dal banner proattivo (bozza.idoneita.problemi) e dall'errore di emissione
 * (422 detail.problemi). I messaggi arrivano dal BE già leggibili (italiano) → verbatim.
 */
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { IdoneitaProblema } from '../../api/fatture';

interface Props {
  problemi: IdoneitaProblema[];
  titolo: string;
  customerId: string;
  testid?: string;
}

export default function IdoneitaProblemiList({ problemi, titolo, customerId, testid }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!problemi || problemi.length === 0) return null;

  const cliente = problemi.filter((p) => p.dove === 'anagrafica cliente');
  const impianto = problemi.filter((p) => p.dove === 'Settings impianto');

  function gruppo(items: IdoneitaProblema[], gid: string, label: string, linkLabel: string, onLink: () => void) {
    if (items.length === 0) return null;
    return (
      <div className="mt-2" data-testid={`idoneita-gruppo-${gid}`}>
        <p className="text-xs font-semibold text-ink-mid">{label}</p>
        <ul className="list-disc list-inside text-xs text-ink-mid">
          {items.map((p, i) => <li key={`${p.campo}-${i}`}>{p.messaggio}</li>)}
        </ul>
        <button type="button" onClick={onLink} data-testid={`idoneita-link-${gid}`}
          className="text-xs font-medium text-sage-dark hover:underline mt-0.5">{linkLabel}</button>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-[#FDE68A] bg-accent-warning-bg p-3" data-testid={testid}>
      <p className="text-sm font-semibold text-ink-dark">{titolo}</p>
      {gruppo(cliente, 'cliente', t('fatturazione.bozza.idoneita_cliente'),
        t('fatturazione.bozza.idoneita_link_cliente'), () => navigate(`/clienti/${customerId}`))}
      {gruppo(impianto, 'impianto', t('fatturazione.bozza.idoneita_impianto'),
        t('fatturazione.bozza.idoneita_link_settings'), () => navigate('/settings'))}
    </div>
  );
}
